import MenuSVG from "@design-system/ui-icons/vanilla/Menu"
import { createIcon } from "../createIcon"

export const MenuIcon = createIcon(MenuSVG)
